import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AdminLayout, { AdminIndexRedirect } from './AdminLayout';
import {
  BooksPage, DashboardPage, EmailsPage, OperationsPage, OrdersPage, PricingPage, ProductsPage, ProvidersPage, SettingsPage, TrafficPage, UsersPage
} from './AdminPages';

// Routes de l'Admin : une adresse propre par section (/admin/commandes, /admin/livres…). Montee sur /admin/* par App.js.
// /admin seul rouvre la derniere section visitee ; une adresse inconnue renvoie a /admin.
// Le serveur garde chaque route d'API independamment : ces routes-ci ne decident que de ce qu'on affiche.
export default function AdminApp() {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<AdminIndexRedirect />} />
        <Route path="tableau-de-bord" element={<DashboardPage />} />
        <Route path="commandes" element={<OrdersPage />} />
        <Route path="livres" element={<BooksPage />} />
        <Route path="utilisateurs" element={<UsersPage />} />
        <Route path="fournisseurs" element={<ProvidersPage />} />
        <Route path="produits" element={<ProductsPage />} />
        <Route path="tarifs" element={<PricingPage />} />
        <Route path="trafic" element={<TrafficPage />} />
        <Route path="exploitation" element={<OperationsPage />} />
        <Route path="e-mails" element={<EmailsPage />} />
        <Route path="reglages" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Route>
    </Routes>
  );
}
